import React, { Fragment, useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

import '../App.scss';

import Navbar from '../components/Navbar';
import FormSearch from '../components/FormSearch';
import Footer from '../components/Footer';
import SearchContent from '../components/SearchContent';
import SearchFilterContent from '../components/SearchFilterContent';
import ServicesSearch from '../services/ServicesSearch';
import ControlBtns from '../components/ControlBtns';

import { getParams } from '../store/params/reducer';
import updateParams from '../store/params/action';
import { connect } from 'react-redux';

const Search = (props) => {
  const [view, setView] = useState('grid');
  const [pymes, setPymes] = useState([]);
  const [loader, setLoader] = useState(true);
  const [total, setTotal] = useState(0);
  const [btnLoader, setBtnLoader] = useState(false);
  const [loc, setLoc] = useState(props.params.location);

  const [show, setShow] = useState(() => {
    return window.innerWidth<768 ? false : true;
  });

  const [showFilters, setShowFilters] = useState(() => {
    return window.innerWidth<768 ? false : true;
  });

  const [search, setSearch] = useState({
    query: props.params.search,
    location: props.params.location,
    [props.params.locationType]: props.params.locationValue,
    defaultLocation: JSON.stringify(props.params.location),
  });

  const [searchTxt, setSearchTxt] = useState(() => {
    return props.params.search ? props.params.search : '';
  });

  const [searchLocTxt, setSearchLocTxt] = useState(() => {
    return props.params.locationTxt ? props.params.locationTxt : '';
  });

  const orderSubcategories = (subcategories) => {
    let response = '?';
    subcategories.forEach((item, i) => {
      response +=
        'subcategories=' + item + (subcategories.length - 1 === i ? '' : '&');
    });
    return response;
  };

  const setFilters = (data, params) => {
    let obj = {};
    data.forEach((d, i) => {
      obj[d] = true;
    });
    return { ...params, ...obj };
  };

  const resetFieldsAndSetLoader = () => {
    if(props.params.from===0){
      setLoader(true);
    }
    setSearchTxt('');
    setSearchLocTxt('');
  };

  const getData = (newLimit, newFrom, queryParams) => {
    resetFieldsAndSetLoader();

    let seed = localStorage.getItem('seed');

    if (!seed) {
      seed = uuidv4();
      localStorage.setItem('seed', seed);
    }

    let params = {
      _size: 18,
      _from: props.params.from,
      _random: seed,
    };

    //Query
    if (props.params.search !== '') {
      params.query = props.params.search;
      setSearchTxt(props.params.search);
    }

    //Location
    if (
      props.params.locationType !== '' &&
      props.params.locationValue !== '' &&
      props.params.locationTxt !== ''
    ) {
      params[props.params.locationType] = props.params.locationValue;
      setSearchLocTxt(props.params.locationTxt);
    }

    //SpecialCategories
    if (props.params.specialCategories.length > 0) {
      params = setFilters(props.params.specialCategories, params);
    }

    //DeliveryMethods
    if (props.params.deliveryMethods.length > 0) {
      params = setFilters(props.params.deliveryMethods, params);
    }

    //PaymentMethods
    if (props.params.paymentMethods.length > 0) {
      params = setFilters(props.params.paymentMethods, params);
    }

    //Categorias
    if (props.params.categories.length > 0) {
      params.categories = props.params.categories.join(',');
    }

    //Subcategorias
    let lastQuery =
      props.params.subcategories.length > 0
        ? orderSubcategories(props.params.subcategories)
        : '';

        // console.log(params);
        // console.log(lastQuery);

    ServicesSearch.getDataPyme(params, lastQuery)
      .then((response) => {
        let array = props.params.from === 0 ? [] : pymes;
        array.push(...response.data['hits']);
        setTotal(response.data['total'].value);
        setPymes(array);
        setLoader(false);
        setBtnLoader(false);
      })
      .catch((e) => {
        setLoader(false);
        setBtnLoader(false);
        console.log(e);
      });
  };

  const displayMoreRcrds = () => {
    setBtnLoader(true);
    let newLimit = props.params.limit + 18;
    let newFrom = props.params.from + 18;
    if (newLimit > total) {
      newLimit = total;
    }
    props.updateParams({
      ...props.params,
      limit: newLimit,
      from: newFrom,
    });
  };

  useEffect(() => {
    getData(18, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.params]);

  return (
    <Fragment>
      <Navbar />
      <div className="row" style={{ paddingBottom: '0px' }}>
        <div className="col-md-12 px-0">

          <ControlBtns
            show={show}
            setShow={setShow}
            showFilters={showFilters}
            setShowFilters={setShowFilters}
            view={'search'}
          />

          <FormSearch
            classForm={'col-lg-12 np-sides'}
            rowClass={'px-0'}
            itemsView={view}
            search={search}
            setSearch={setSearch}
            loc={loc}
            setLoc={setLoc}
            responsiveMenu={true}
            show={show}
            setShow={setShow}
          />
        </div>
      </div>

      <div className="row py-0 d-none d-sm-block">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb px-0 py-0">
            <li className="breadcrumb-item"><a href="/" style={{color:'#000000'}}>Compra Pyme</a></li>
            <li className="breadcrumb-item active" aria-current="page">Resultados de búsqueda</li>
          </ol>
        </nav>
      </div>
      <div className="row">
        <div className="col-es-3">
          <SearchFilterContent
            setSearch={setSearch}
            setLoc={setLoc}
            showFilters={showFilters}
            setShowFilters={setShowFilters}
          />
        </div>
        <div className="col-es-9">
          <SearchContent
            displayMoreRcrds={displayMoreRcrds}
            pymes={pymes}
            loader={loader}
            total={total}
            btnLoader={btnLoader}
            view={view}
            setView={setView}
            searchTxt={searchTxt}
            searchLocTxt={searchLocTxt}
          />
        </div>
      </div>
      <Footer />
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    params: getParams(state),
  };
};

export default connect(mapStateToProps, { updateParams })(Search);
